import React, { FC } from "react";
import { Button, Card, CardBody } from "reactstrap";
import clsx from "clsx";
import { Link } from "react-router-dom";

export interface ICampaignCard {
  isSidebarOpen: boolean;
  data: any;
}

const CampaignCard: FC<ICampaignCard> = ({ isSidebarOpen, data }) => {
  return (
    <React.Fragment>
      <Card
        className={clsx("m-3 sidebar-campaing", !isSidebarOpen && "d-none")}
      >
        <CardBody>
          <img src={data.image} alt="campaign" className="img-fluid" />
          <h3 className="text-white text-center my-3 campaign-name">
            {data.contentText}
          </h3>
          <div className="campaign-button">
            <Link
              to={data.url}
              target={data.target}
              className="rounded-pill bg-dark px-3 link-btn-custom"
            >
              {data.buttonText}
            </Link>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default CampaignCard;
